import { VenueUserFeedbackOptionType } from '@classpass/protobuf-definitions/lib/web/models/partners/reservation';
import { BookingType } from '@classpass/protobuf-definitions/lib/web/models/shared/reservation_service/booking';

import { ICONS } from 'constants/icons';
import { CLASS_ENTITY_TYPE } from 'constants/logic';

import { submitBookingFeedback, submitReservationFeedback } from './ReservationFeedback.helpers';
import messages from './ReservationFeedbackModalV2.messages';

const WHAT_TO_INCLUDE_GUIDELINE = {
  icon: ICONS.clipboard,
  title: messages.disruptiveUserGuidelineIncludeTitle,
  description: [
    messages.disruptiveUserGuidelineDateDescription,
    messages.disruptiveUserGuidelineFactDescription,
    messages.disruptiveUserGuidelineFrequencyDescription,
    messages.disruptiveUserGuidelineStepsTakenDescription,
    messages.disruptiveUserGuidelineAffectedDescription,
  ],
};

const RESERVATION_REPORT_RULES = {
  offersTrialAbuse: classEntityType => classEntityType === CLASS_ENTITY_TYPE.CLASS,
  disruptiveUserDescription: messages.disruptiveUserDescription,
  disruptiveReasons: [
    { message: messages.disruptiveReasonNotFollowingPolicy, value: VenueUserFeedbackOptionType.NOT_FOLLOWING_POLICY },
    { message: messages.disruptiveReasonRepeatedlyLate, value: VenueUserFeedbackOptionType.LATE },
    { message: messages.disruptiveReasonRudeToStaff, value: VenueUserFeedbackOptionType.RUDE },
  ],
  disruptiveUserGuidelines: [
    {
      icon: ICONS.pointUp,
      title: messages.disruptiveUserGuidelineExamplesTitle,
      description: [
        messages.disruptiveUserGuidelineLateDescription,
        messages.disruptiveUserGuidelinePolicyDescription,
        messages.disruptiveUserGuidelineRudeDescription,
      ],
      descriptionFooter: messages.disruptiveUserGuidelineSeriousBehaviorNote,
    },
    WHAT_TO_INCLUDE_GUIDELINE,
  ],
  submit: ({ reservationId, feedback, description }) =>
    submitReservationFeedback({ reservationId, feedback, description }),
};

const ORDER_REPORT_RULES = {
  offersTrialAbuse: () => false,
  disruptiveUserDescription: messages.orderDisruptiveUserDescription,
  disruptiveReasons: [
    {
      message: messages.disruptiveReasonNotFollowingStorePolicy,
      value: VenueUserFeedbackOptionType.NOT_FOLLOWING_POLICY,
    },
    { message: messages.disruptiveReasonRudeToStaff, value: VenueUserFeedbackOptionType.RUDE },
  ],
  disruptiveUserGuidelines: [
    {
      icon: ICONS.pointUp,
      title: messages.orderDisruptiveUserGuidelineExamplesTitle,
      description: [
        messages.orderDisruptiveUserGuidelinePolicyDescription,
        messages.orderDisruptiveUserGuidelineUncomfortableDescription,
        messages.orderDisruptiveUserGuidelineAggressionDescription,
        messages.orderDisruptiveUserGuidelineMisuseDescription,
      ],
      descriptionFooter: messages.disruptiveUserGuidelineSeriousBehaviorNote,
    },
    WHAT_TO_INCLUDE_GUIDELINE,
  ],
  submit: ({ orderId, feedback, description }) =>
    submitBookingFeedback({ bookingType: BookingType.ORDER, bookingId: orderId, feedback, description }),
};

const REPORT_RULES_BY_BOOKING_TYPE = {
  [BookingType.RESERVATION]: RESERVATION_REPORT_RULES,
  [BookingType.ORDER]: ORDER_REPORT_RULES,
};

export const REPORTABLE_BOOKING_TYPES = [BookingType.RESERVATION, BookingType.ORDER];

export const getReportRules = bookingType => REPORT_RULES_BY_BOOKING_TYPE[bookingType];
